import { writable } from "svelte/store"

export let selectedCategory = writable("");
